import { enableProdMode } from '@angular/core';
import { environment } from '@environments/environment';
import { CreateBoApp } from '@core/app/create-bo-app';
import { CommonAppComponent } from '@ui/layout/common-app/common-app.component';
import { appConfig } from './app/app.config';


if (environment.production) {
    enableProdMode();
}

new CreateBoApp(CommonAppComponent, appConfig).initApp();
